export default "__VITE_ASSET__C0NM4_GV__"